import { render, staticRenderFns } from "./MythsBusters.vue?vue&type=template&id=4a61ca42&scoped=true&"
import script from "./MythsBusters.vue?vue&type=script&lang=js&"
export * from "./MythsBusters.vue?vue&type=script&lang=js&"
import style0 from "./MythsBusters.vue?vue&type=style&index=0&id=4a61ca42&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a61ca42",
  null
  
)

export default component.exports